import React from "react";

export const PrejuridicoContext = React.createContext();